import { createLanguageSkillQuery } from 'components/SearchSideBar/logics/createQuery/details/languageSkill';
import { GetInitialIdListArgument } from 'components/SearchSideBar/types';

/**
 * id配列を取得
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @returns {string[]} id配列
 */
export const getInitialIdList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
}: GetInitialIdListArgument) => {
  // 保存した検索条件
  if (savedSearchCondition) {
    const idList = savedSearchCondition.languageSkillsList
      ? createLanguageSkillQuery(savedSearchCondition.languageSkillsList)
      : [];

    return idList;
  }

  // 特集枠検索条件
  if (featuredSearchCondition) {
    const idList = featuredSearchCondition.languageSkills
      ? createLanguageSkillQuery(featuredSearchCondition.languageSkills)
      : [];

    return idList;
  }

  // クエリから取得した検索条件
  return queries ?? [];
};
